<div id="content" class="workSpace">
  <!-- filtros -->
  <div class="w3-container w3-container-template headersTab">
    <!--Titulo de modulo y subtitulo-->
    <div class="w3-caja-menu padreizquierda w3-thirty">
      <div class="w3-row hijoizquierda centradoVertical">
        <span class="w3-text-deep-orange w3-margin-right-filter w3-tituloPrincipal"> <b> {{ 'menu.'+dataService.moduleSelect | translate }} </b></span>
        <span class="w3-text-deep-orange">&bull;</span>
        <span class="w3-text-orange w3-margin-left-filter w3-subtituloPrincipal"> {{ 'menu.'+dataService.subModuleSelect | translate }} </span>
      </div>
    </div>
    <!--Filtros-->
    <div class="w3-caja-menu padreizquierda w3-rest" style="height: 100%">
      <div class="w3-half w3-row centradoVertical">
        <div class="w3-quarter">
          <div class="w3-right" style="margin-right: 5%;" [ngClass]="{ 'w3-disabled': !filtroPeriodos }">
            {{ 'filtros.rango' | translate }}
          </div>
          <div class="w3-right" style="margin-right: 5%; margin-top: 1%;">
            <input (click)="activacionFiltros()" class="" style="border-width: 1px;" type="checkbox">
          </div>
      </div>
      <div class="w3-rest"  [ngClass]="{ 'w3-disabled': !filtroPeriodos }">
        {{ 'filtros.desde' | translate }}

        @for (anio of Periodos; track $index) {
          @for (mes of anio.series; track $index) {
            <div [ngClass]="{ 'fraseFil w3-round-btn-large w3-center w3-elemento-menu grisBtn w3-button iconoFiltros': mes.check, 'w3-hide': !mes.check}"
            [matMenuTriggerFor]="menuAniosIni">
              <span style="margin-left: 5px;">{{escrituraPeriodo(mes.periodo)}}</span>
            </div>
          }
        }
        <mat-menu class="w3-medium" #menuAniosIni="matMenu">
          @for (anio of Periodos; track $index) {
            <button class="mat-menu-item" mat-menu-item [matMenuTriggerFor]="menuMeses">
              {{anio.anio}}
            </button>
            <mat-menu #menuMeses="matMenu" [overlapTrigger]="false">
              @for (mes of anio.series; track $index) {
                <button mat-menu-item (click)="$event.stopPropagation(); cambioPeriodo(mes, 'inicio');">
                  <input [id]="'check_'+mes.mes+''+mes.anio"
                  (change)="cambioPeriodo(mes, 'inicio')" style="cursor: pointer; margin-top: 0.7vh; float: left;"
                  [checked]="mes.check" type="checkbox"
                  (click)="$event.stopPropagation();">
                  <span style="margin-left: 5px; float: left;">{{'filtros.'+mes.mes|translate}}</span> 
                </button>
              }
            </mat-menu>
          }
        </mat-menu>

        {{ 'filtros.hasta' | translate }}

        @for (anio of Periodos2; track $index) {
          @for (mes of anio.series; track $index) {
            <div [ngClass]="{ 'fraseFil w3-round-btn-large w3-center w3-elemento-menu grisBtn w3-button iconoFiltros': mes.check, 'w3-hide': !mes.check}"
            [matMenuTriggerFor]="menuAniosFin">
              <span style="margin-left: 5px;">{{escrituraPeriodo(mes.periodo)}}</span>
            </div>
          }
        }
        <mat-menu class="w3-medium" #menuAniosFin="matMenu">
          @for (anio of Periodos2; track $index) {
            @if (anio.visible) {
              <button class="mat-menu-item" mat-menu-item [matMenuTriggerFor]="menuMeses2">
                {{anio.anio}}
              </button>
            }
            <mat-menu #menuMeses2="matMenu" [overlapTrigger]="false">
              @for (mes of anio.series; track $index) {
                @if (mes.visible) {
                  <button mat-menu-item (click)="$event.stopPropagation(); cambioPeriodo(mes, 'fin');">
                    <input [id]="'check_'+mes.mes+''+mes.anio"
                    (change)="cambioPeriodo(mes, 'fin')" style="cursor: pointer; margin-top: 0.7vh; float: left;"
                    [checked]="mes.check" type="checkbox"
                    (click)="$event.stopPropagation();">
                    <span style="margin-left: 5px; float: left;">{{'filtros.'+mes.mes|translate}}</span> 
                  </button>
                }
              }
            </mat-menu>
          }
        </mat-menu>
      </div>
      </div>
    </div>
  </div>
  <!-- tablero -->
  <div class="w3-row workSpaceTab">
    <div id="table" style="height: 100%; width: 100%;">
      <div class="w3-row headers w3-titulo-contenidomenuSC">
        <div class="w3-half">
          <span class="w3-margin-left-contenido">{{ 'operative.matriz-eventos.titulo-principal' | translate }}</span>
          <span class="w3-margin-left-filter w3-subtitulo"></span>
        </div>
        <div class="w3-rest w3-right" style="margin-top: 1vh;">
        </div>
      </div>
      <div class="tableZone">
        <div class="zonaSelects">
          <div class="w3-row" style="margin-bottom: 5px;">
            <div class="w3-quarter">
              {{'operative.matriz-eventos.formulario-opcion-area'|translate}}
            </div>
            <div class="w3-quarter">
              {{'operative.matriz-eventos.formulario-opcion-agencia'|translate}}
            </div>
            <div class="w3-quarter">
              {{'operative.matriz-eventos.formulario-opcion-categoria'|translate}}
            </div>
          </div>
          <div [formGroup]="formSelects">
            <div class="w3-quarter" style="height: 4vh;">
              <select class="contentSelectFil" formControlName="area" (change)="selecCategoriaFilter()">
                <option value="default"> {{'operative.matriz-eventos.formulario-opcion-default' | translate}} </option>
                @for (option of area; track $index) {
                  <option value="{{option.id}}">{{option.name}}</option>
                }
              </select>
            </div>
            <div class="w3-quarter" style="height: 4vh;">
              <select class="contentSelectFil" formControlName="agencia" (change)="selecCategoriaFilter()">
                <option value="default"> {{'operative.matriz-eventos.formulario-opcion-default' | translate}} </option>
                @for (option of agencia; track $index) {
                  <option value="{{option.id}}">{{option.name}}</option>
                }
              </select>
            </div>
            <div class="w3-quarter" style="height: 4vh;">
              <select class="contentSelectFil" formControlName="categoria" (change)="selecCategoriaFilter()">
                <option value="default"> {{'operative.matriz-eventos.formulario-opcion-default' | translate}} </option>
                @for (option of categorias; track $index) {
                  <option value="{{option.id}}">{{option.name}}</option>
                }
              </select>
            </div>
            <div class="w3-rest" style="height: 4vh;">
              <div class="w3-quarter" style="height: 4vh;">
                <div [ngClass]="{'w3-disabled': formSelects.controls['categoria'].value === 'default' && formSelects.controls['area'].value === 'default'
                && formSelects.controls['agencia'].value === 'default' }" class="w3-margin-right-contenido w3-button w3-dropdown-click iconoDeletFiltros"
                [ngStyle]="{'color': 'grey'}" matTooltip="{{'tooltips.borrar-filtros' | translate}}" (click)="borrarFiltro()">
                  <img src="./../../../../assets/img/eraser.png">
                </div>
              </div>
              <div class="w3-rest w3-right" style="height: 4vh;">
                <mat-icon *appRolesNeg="permisos.ADMINISTRACION_" class="w3-margin-right-contenido iconoDeletFiltros colorBotonDeNuevo" (click)="agregar()">
                  add_circle_outline
                </mat-icon>
                <mat-icon *appRoles="permisos.ADMINISTRACION_"  class="w3-margin-right-contenido iconoDeletFiltros colorBotonDeNuevo" [matMenuTriggerFor]="addElements">
                  add_circle_outline
                </mat-icon>
                <mat-menu #addElements="matMenu">
                  <button (click)="agregar()" class="mat-menu-item" mat-menu-item class="w3-caja-menu">
                    <span>{{'operative.matriz-eventos.menu-agregar-1'|translate}}</span>
                  </button>
                  <button (click)="agregarArchivo()" class="mat-menu-item" mat-menu-item class="w3-caja-menu">
                    <span>{{'operative.matriz-eventos.menu-agregar-2'|translate}}</span>
                  </button>
                </mat-menu>
                @if (existSelec) {
                  @if (seleccionados === 1) {
                    <mat-icon class="w3-margin-right-contenido w3-button w3-dropdown-click iconoDeletFiltros" [ngStyle]="{'color':'gray'}" (click)="editar()">
                      edit_outline
                    </mat-icon>
                  }
                  <mat-icon class="w3-margin-right-contenido w3-button w3-dropdown-click iconoDeletFiltros" [ngStyle]="{'color':'gray'}" (click)="copiar()">
                    content_copy
                  </mat-icon>
                  <mat-icon class="w3-margin-right-contenido w3-button w3-dropdown-click iconoDeletFiltros" [ngStyle]="{'color':'gray'}" (click)="eliminar()">
                    delete_outline
                  </mat-icon>
                }
                <mat-icon class="w3-margin-right-contenido w3-button w3-dropdown-click iconoDeletFiltros" [ngStyle]="{'color':'gray'}"  [matMenuTriggerFor]="menu">
                  more_vert
                </mat-icon>
                <mat-menu #menu="matMenu">
                  <button class="mat-menu-item" mat-menu-item class="w3-caja-menu" (click)="exportarExcel()">
                    <mat-icon [ngStyle]="{'color':'gray'}">description</mat-icon>
                    <span>{{'menu.exportar' | translate}}</span>
                  </button>
                </mat-menu>
              </div>
            </div>
          </div>
        </div>
        <div class="tabla w3-scroll">
          <table class="w3-table allbordes">
            <thead>
              <tr class="w3-table-title">
                <th class="w3-border-right-balance w3-center stikyColum"> {{'operative.matriz-eventos.titulo-tabla-1' | translate}} </th>
                <th class="w3-border-right-balance w3-center stikyColum"> {{'operative.matriz-eventos.titulo-tabla-2' | translate}} </th>
                <th class="w3-border-right-balance w3-center stikyColum"> {{'operative.matriz-eventos.titulo-tabla-3' | translate}} </th>
                <th class="w3-border-right-balance w3-center stikyColum"> {{'operative.matriz-eventos.titulo-tabla-4' | translate}} </th>
                <th class="w3-border-right-balance w3-center stikyColum"> {{'operative.matriz-eventos.titulo-tabla-5' | translate}} </th>
                <th class="w3-border-right-balance w3-center contenedorSort stikyColum" (click)="ordenar('event_date')"> {{'operative.matriz-eventos.titulo-tabla-6' | translate}}
                  <mat-icon [ngClass]="{'iconoSortIni': ordenado==='norm','iconoSort': ordenado!=='norm'}">{{icono()}}</mat-icon>
                </th>
                <th *appRolesNeg="permisos.VALIDACION" class="w3-border-right-balance w3-center stikyColum"> {{'operative.matriz-eventos.titulo-tabla-7' | translate}} </th>
                <th *appRoles="permisos.VALIDACION" class="w3-border-right-balance w3-center stikyColum"> {{'operative.matriz-eventos.titulo-tabla-8' | translate}} </th>
              </tr>
            </thead>
            @for (item of dataOrdenado; track item; let i = $index) {
              <tbody>
                <tr class="w3-table-trtd">
                  <td class="borderAllLow marginIzq alinCenter" [ngClass]="{'w3-table-titleLow' : item.select}" (click)="seleccion(item)">{{i+1}}</td>
                  <td class="borderAllLow marginIzq " [ngClass]="{'w3-table-titleLow' : item.select}" (click)="seleccion(item)">{{ escritura('area',item) }}</td>
                  <td class="borderAllLow marginIzq " [ngClass]="{'w3-table-titleLow' : item.select}" (click)="seleccion(item)">{{ escritura('agencia',item) }}</td>
                  <td class="borderAllLow marginIzq " [ngClass]="{'w3-table-titleLow' : item.select}" (click)="seleccion(item)">{{ escritura('categoria',item) }}</td>
                  <td class="borderAllLow marginIzq " [ngClass]="{'w3-table-titleLow' : item.select}" (click)="seleccion(item)">{{ escritura('evento',item) }}</td>
                  <td class="borderAllLow marginIzq alinCenter" [ngClass]="{'w3-table-titleLow' : item.select}" (click)="seleccion(item)">{{ escritura('fecha',item) }}</td>
                  <td *appRoles="permisos.VALIDACION" class="borderAllLow alinCenter" [ngClass]="{'w3-table-titleLow' : item.select}">
                    @switch (item.event_status) {
                      @case (1) {
                        <mat-icon class="w3-button w3-dropdown-click" [ngStyle]="{'color':'green'}" matTooltipPosition="left" matTooltip="Validar" (click)="validaciones(item, 3)">done</mat-icon>
                        <mat-icon class="w3-button w3-dropdown-click" [ngStyle]="{'color':'red'}" matTooltipPosition="left" matTooltip="Regresar" (click)="validaciones(item, 4)">close</mat-icon>
                      }
                      @case (2) {
                        <mat-icon class="w3-button w3-dropdown-click" [ngStyle]="{'color':'green'}" matTooltipPosition="left" matTooltip="Validar" (click)="validaciones(item, 3)">done</mat-icon>
                        <mat-icon class="w3-button w3-dropdown-click" [ngStyle]="{'color':'red'}" matTooltipPosition="left" matTooltip="Regresar" (click)="validaciones(item, 4)">close</mat-icon>
                      }
                      @case (3) {
                        <mat-icon class="w3-button w3-dropdown-click" [ngStyle]="{'color':'green'}" matTooltipPosition="left" matTooltip="{{escritura('estatus',item)}}">task_alt</mat-icon>
                      }
                      @case (4) {
                        <mat-icon class="w3-button w3-dropdown-click" [ngStyle]="{'color':'red'}" matTooltipPosition="left" matTooltip="{{escritura('estatus',item)}}">cancel</mat-icon>
                      }
                    }
                  </td>
                  <td *appRolesNeg="permisos.VALIDACION" class="borderAllLow alinCenter" [ngClass]="{'w3-table-titleLow' : item.select}">
                    @switch (item.event_status) {
                      @case (1) {
                        <mat-icon class="w3-button w3-dropdown-click" [ngStyle]="{'color':'orange'}" matTooltip="{{escritura('estatus',item)}}" (click)="validaciones(item, 2)">forward_to_inbox</mat-icon>
                      }
                      @case (2) {
                        <mat-icon class="w3-button w3-dropdown-click" [ngStyle]="{'color':'gray'}" matTooltip="{{escritura('estatus',item)}}" fontSet="material-icons-outlined">watch_later</mat-icon>
                      }
                      @case (3) {
                        <mat-icon class="w3-button w3-dropdown-click" [ngStyle]="{'color':'green'}" matTooltip="{{escritura('estatus',item)}}">task_alt</mat-icon>
                      }
                      @case (4) {
                        <mat-icon class="w3-button w3-dropdown-click" [ngStyle]="{'color':'red'}" matTooltip="{{escritura('estatus',item)}}">cancel</mat-icon>
                      }
                    }
                  </td>
                </tr>
              </tbody>
            }
          </table>
        </div>
      </div>
    </div>
    <div id="form" class="formularioCla" style="display: none;">
      <div class="w3-row headers w3-titulo-contenidomenuSC">
        <div class="w3-half">
          @if (agr) {
            <span class="w3-margin-left-contenido">{{ 'operative.matriz-eventos.agregar' | translate }}</span>
          }
          @if(edi){
            <span class="w3-margin-left-contenido">
              <mat-icon class="" [ngStyle]="{'color':'gray'}" style="vertical-align: middle; opacity: 1; transform: scale(0.7);">
                edit_outline
              </mat-icon>
            </span>
            <span>{{ 'operative.matriz-eventos.editar' | translate }}</span>
            <span class="w3-margin-left-filter w3-subtitulo"></span>
          }
        </div>
        <div class="w3-rest w3-right" style="margin-top: 1vh;">
          <mat-icon class="w3-margin-right-contenido w3-button w3-dropdown-click" [ngStyle]="{'color':'gray'}" (click)="info()">
            info_outline
          </mat-icon>
          <mat-icon class="w3-margin-right-contenido w3-button w3-dropdown-click" [ngStyle]="{'color':'gray'}" (click)="cerrar()">
            close
          </mat-icon>
        </div>
      </div>
      <div class="w3-row tableZone">
        <div class="w3-row" [formGroup]="formEvento">
          <div style="width: 98%; margin-top: 1%; margin-left: auto; margin-right: auto;">
            
            <mat-accordion class="example-headers-align">
              <!-- Zona 1 -->
              <mat-expansion-panel [expanded]="step === 0" (opened)="setStep(0)">
                <mat-expansion-panel-header style="background-color: rgb(230, 230, 230);">
                  <mat-panel-title>
                    <span class="w3-margin-left-contenido tituloZonasMatDivider"> {{'operative.matriz-eventos.zona-form-1' | translate}} </span>
                  </mat-panel-title>
                </mat-expansion-panel-header>
                
                <br>
                <div class="w3-half" style="margin-top: 1vh;">
                  <div class="texto">
                    <div class="w3-right zonaTexto"><span class="w3-right textoInputs"> {{'operative.matriz-eventos.formulario-opcion-area'|translate}}: </span></div>
                  </div>
                  <div class="w3-rest">
                    <div class="zonaInput">
                      <select class="contentSelect" formControlName="area" value="default">
                        <option value="default"> Seleccione: </option>
                        @for (opt of area; track $index) {
                          <option value="{{opt.id}}">{{opt.name}}</option>
                        }
                      </select>
                    </div>
                  </div>
                </div>
                <div class="w3-half" style="margin-top: 1vh;">
                  <div class="texto">
                    <div class="w3-right zonaTexto"><span class="w3-right textoInputs"> {{'operative.matriz-eventos.formulario-opcion-agencia'|translate}}: </span></div>
                  </div>
                  <div class="w3-rest">
                    <div class="zonaInput">
                      <select class="contentSelect" formControlName="agencia">
                        <option value="default"> Seleccione: </option>
                        @for (opt of agencia; track $index) {
                          <option value="{{opt.id}}">{{opt.name}}</option>
                        }
                      </select>
                    </div>
                  </div>
                </div>
                <div class="w3-half" style="margin-top: 1vh;">
                  <div class="texto">
                    <div class="w3-right zonaTexto"><span class="w3-right textoInputs"> {{'operative.matriz-eventos.formulario-opcion-categoria'|translate}}: </span></div>
                  </div>
                  <div class="w3-rest">
                    <div class="zonaInput">
                      <select class="contentSelect" formControlName="categoria" (change)="selecCategoria()">
                        <option value="default"> Seleccione: </option>
                        @for (opt of categorias; track $index) {
                          <option value="{{opt.id}}">{{opt.name}}</option>
                        }
                      </select>
                    </div>
                  </div>
                </div>
                @if (niveles >= 2) {
                  <div class="w3-half" style="margin-top: 1vh;">
                    <div class="texto">
                      <div class="w3-right zonaTexto"><span class="w3-right textoInputs"> {{'operative.matriz-eventos.formulario-opcion-concepto'|translate}}: </span></div>
                    </div>
                    <div class="w3-rest">
                      <div class="zonaInput" [ngClass]="{ 'w3-disabled' : formEvento.controls['categoria'].value==='default' }">
                        <select class="contentSelect" formControlName="concepto" (change)="selecConcepto()">
                          <option value="default"> Seleccione: </option>
                          @for (opt of conceptos; track $index) {
                            <option value="{{opt.id}}">{{opt.name}}</option>
                          }
                        </select>
                      </div>
                    </div>
                  </div>
                }
                @if (niveles >= 3) {
                  <div class="w3-half" style="margin-top: 1vh;">
                    <div class="texto">
                      <div class="w3-right zonaTexto"><span class="w3-right textoInputs"> {{'operative.matriz-eventos.formulario-opcion-evento'|translate}}: </span></div>
                    </div>
                    <div class="w3-rest">
                      <div class="zonaInput" [ngClass]="{ 'w3-disabled' : formEvento.controls['concepto'].value==='default' }">
                        <select class="contentSelect" formControlName="evento">
                          <option value="default"> Seleccione: </option>
                          @for (opt of eventos; track $index) {
                            <option value="{{opt.id}}">{{opt.name}}</option>
                          }
                        </select>
                      </div>
                    </div>
                  </div>
                }
                <div class="w3-half" style="margin-top: 1vh;">
                  <div class="texto">
                    <div class="w3-right zonaTexto"><span class="w3-right textoInputs"> {{'operative.matriz-eventos.formulario-opcion-fecha-evento'|translate}}: </span></div>
                  </div>
                  <div class="w3-rest">
                    <div class="zonaInput">
                      <input type="date" class="contentDate" formControlName="fecha">
                    </div>
                  </div>
                </div>
                <div class="w3-half" style="margin-top: 1vh;">
                  <div class="texto">
                    <div class="w3-right zonaTexto"><span class="w3-right textoInputs"> {{'operative.matriz-eventos.formulario-opcion-detalle-evento'|translate}}: </span></div>
                  </div>
                  <div class="w3-rest">
                    <div class="zonaInput">
                      <input type="text" class="contentInput" formControlName="detalle" matTooltip="{{formEvento.controls['detalle'].value}}">
                    </div>
                  </div>
                </div>
                <div class="w3-half" style="margin-top: 1vh;">
                  <div class="texto">
                    <div class="w3-right zonaTexto"><span class="w3-right textoInputs"> {{'operative.matriz-eventos.formulario-opcion-accion-realizada'|translate}}: </span></div>
                  </div>
                  <div class="w3-rest">
                    <div class="zonaInput">
                      <select class="contentSelect" formControlName="accion">
                        <option value="default"> Seleccione: </option>
                        @for (opt of accion; track $index) {
                          <option value="{{opt.id}}">{{opt.name}}</option>
                        }
                      </select>
                    </div>
                  </div>
                </div>
                <div class="w3-half" style="margin-top: 1vh;">
                  <div class="texto">
                    <div class="w3-right zonaTexto"><span class="w3-right textoInputs"> {{'operative.matriz-eventos.formulario-opcion-fuente'|translate}}: </span></div>
                  </div>
                  <div class="w3-rest">
                    <div class="zonaInput">
                      <select class="contentSelect" formControlName="fuente">
                        <option value="default"> Seleccione: </option>
                        @for (opt of fuente; track $index) {
                          <option value="{{opt.id}}">{{opt.name}}</option>
                        }
                      </select>
                    </div>
                  </div>
                </div>
                <div class="w3-half" style="margin-top: 1vh;">
                  <div class="texto">
                    <div class="w3-right zonaTexto"><span class="w3-right textoInputs"> {{'operative.matriz-eventos.formulario-opcion-riesgo-derivado'|translate}}: </span></div>
                  </div>
                  <div class="w3-rest">
                    <div class="zonaInput">
                      <select class="contentSelect" formControlName="riesgo">
                        <option value="default"> Seleccione: </option>
                        @for (opt of riesgo; track $index) {
                          <option value="{{opt.id}}">{{opt.name}}</option>
                        }
                      </select>
                    </div>
                  </div>
                </div>

                <mat-action-row style="margin-top: 1vh;">
                  <div class="botonesModales" (click)="nextStep()">
                    <button mat-stroked-button color="success" style="height: 3vh; width: 100%;">{{'operative.matriz-eventos.botones-form-2' | translate}}</button>
                  </div>
                </mat-action-row>

              </mat-expansion-panel>
              <!-- Zona 2 -->
              <mat-expansion-panel [expanded]="step === 1" (opened)="setStep(1)">
                <mat-expansion-panel-header style="background-color: rgb(230, 230, 230);">
                  <mat-panel-title>
                    <span class="w3-margin-left-contenido tituloZonasMatDivider"> {{'operative.matriz-eventos.zona-form-2' | translate}} </span>
                  </mat-panel-title>
                </mat-expansion-panel-header>

                <br>
                <div class="w3-half" style="margin-top: 1vh;">
                  <div class="texto">
                    <div class="w3-right zonaTexto"><span class="w3-right textoInputs"> {{'operative.matriz-eventos.formulario-opcion-perdida'|translate}}: </span></div>
                  </div>
                  <div class="w3-rest">
                    <div class="zonaInput">
                      <select class="contentSelect" formControlName="perdida" (change)="ingresoMontosForm()">
                        <option value="default"> Seleccione: </option>
                        @for (opt of perdida; track $index) {
                          <option value="{{opt.id}}">{{opt.name}}</option>
                        }
                      </select>
                    </div>
                  </div>
                </div>
                <div class="w3-half" [ngClass]="{'w3-disabled': !ingresoMontos}" style="margin-top: 1vh;">
                  <div class="texto">
                    <div class="w3-right zonaTexto"><span class="w3-right textoInputs"> {{'operative.matriz-eventos.formulario-opcion-monto-perdida'|translate}}: </span></div>
                  </div>
                  <div class="w3-rest">
                    <div class="zonaInput">
                      <input currencyMask class="contentInputNumber"
                        [options]="{prefix: ''+prefix, thousands: ''+miles, decimal: ''+decimal, precision: precicion,suffix: ' '+suffix, align: aling}"
                        formControlName="monto">
                    </div>
                  </div>
                </div>
                <div class="w3-half" [ngClass]="{'w3-disabled': !ingresoMontos}" style="margin-top: 1vh;">
                  <div class="texto">
                    <div class="w3-right zonaTexto"><span class="w3-right textoInputs"> {{'operative.matriz-eventos.formulario-opcion-perdida-trasladada'|translate}}: </span></div>
                  </div>
                  <div class="w3-rest">
                    <div class="zonaInput" style="height: 6vh !important;" [ngClass]="{ 'w3-disabled' : formEvento.controls['monto'].value === '' }">
                      <input currencyMask class="contentInputNumber"
                      [options]="{ prefix: ''+prefix, thousands: ''+miles, decimal: ''+decimal, precision: precicion,suffix: ' '+suffix, align: aling}"
                      formControlName="perdidaTras">
                      @if (formEvento.hasError('isValid')) {
                        <mat-error class="error-message">
                          La <span style="text-decoration: underline;">Pérdida trasladada</span>, no debe exder el <strong> Monto de pérdida </strong>
                        </mat-error>
                      }
                    </div>
                  </div>
                </div>

                <mat-action-row style="margin-top: 1vh;">
                  <div class="botonesModales" (click)="prevStep()">
                    <button mat-stroked-button color="success2" style="height: 3vh; width: 100%;">{{'operative.matriz-eventos.botones-form-1' | translate}}</button>
                  </div>
                  <div class="botonesModales" (click)="nextStep()">
                    <button mat-stroked-button color="success" style="height: 3vh; width: 100%;">{{'operative.matriz-eventos.botones-form-2' | translate}}</button>
                  </div>
                </mat-action-row>

              </mat-expansion-panel>
              <!-- Zona 3 -->
              <mat-expansion-panel [expanded]="step === 2" (opened)="setStep(2)">
                <mat-expansion-panel-header style="background-color: rgb(230, 230, 230);">
                  <mat-panel-title>
                    <span class="w3-margin-left-contenido tituloZonasMatDivider"> {{'operative.matriz-eventos.zona-form-3' | translate}} </span>
                  </mat-panel-title>
                </mat-expansion-panel-header>

                <br>
                <div class="w3-half" style="margin-top: 1vh;">
                  <div class="texto">
                    <div class="w3-right zonaTexto"><span class="w3-right textoInputs"> {{'operative.matriz-eventos.formulario-opcion-impacto'|translate}}: </span></div>
                  </div>
                  <div class="w3-rest">
                    <div class="zonaInput">
                      <select class="contentSelect" formControlName="impacto" (change)="riesgoImp()">
                        <option value="default"> Seleccione: </option>
                        @for (opt of impacto; track $index) {
                          <option value="{{opt.id}}">{{opt.name}}</option>
                        }
                      </select>
                    </div>
                  </div>
                </div>
                <div class="w3-half" style="margin-top: 1vh;">
                  <div class="texto">
                    <div class="w3-right zonaTexto"><span class="w3-right textoInputs"> {{'operative.matriz-eventos.formulario-opcion-probabilidad'|translate}}: </span></div>
                  </div>
                  <div class="w3-rest">
                    <div class="zonaInput">
                      <select class="contentSelect" formControlName="probabilidad" (change)="riesgoImp()">
                        <option value="default"> Seleccione: </option>
                        @for (opt of probabilidad; track $index) {
                          <option value="{{opt.id}}">{{opt.name}}</option>
                        }
                      </select>
                    </div>
                  </div>
                </div>
                <div class="w3-half" style="margin-top: 1vh;">
                  <div class="texto">
                    <div class="w3-right zonaTexto"><span class="w3-right textoInputs"> {{'operative.matriz-eventos.formulario-opcion-control'|translate}}: </span></div>
                  </div>
                  <div class="w3-rest">
                    <div class="zonaInput">
                      <select class="contentSelect" formControlName="control" (change)="controlImp()">
                        <option value="default"> Seleccione: </option>
                        @for (opt of control; track $index) {
                          <option value="{{opt.id}}">{{opt.name}}</option>
                        }
                      </select>
                    </div>
                  </div>
                </div>
                <div class="w3-half" style="margin-top: 1vh;">
                  <div class="texto">
                    <div class="w3-right zonaTexto2"><span class="w3-right textoInputs"> {{'operative.matriz-eventos.formulario-opcion-riesgo-implicito'|translate}}: </span></div>
                  </div>
                  <div class="w3-rest">
                    <div class="zonaInput">
                      <input type="text" class="contentInput" formControlName="riesgoImp">
                    </div>
                  </div>
                </div>
                <div class="w3-half" style="margin-top: 1vh;">
                  <div class="texto">
                    <div class="w3-right zonaTexto2"><span class="w3-right textoInputs"> {{'operative.matriz-eventos.formulario-opcion-porcentaje-control'|translate}}: </span></div>
                  </div>
                  <div class="w3-rest">
                    <div class="zonaInput">
                      <input  currencyMask class="contentInputNumber"
                      [options]="{prefix: ''+prefix, thousands: ''+miles, decimal: ''+decimal, precision: 0,suffix: ' %', align: aling}" formControlName="porControl">
                    </div>
                  </div>
                </div>
                <div class="w3-half" style="margin-top: 1vh;">
                  <div class="texto">
                    <div class="w3-right zonaTexto2"><span class="w3-right textoInputs"> {{'operative.matriz-eventos.formulario-opcion-porcentaje-controlar'|translate}}: </span></div>
                  </div>
                  <div class="w3-rest">
                    <div class="zonaInput">
                      <input currencyMask class="contentInputNumber"
                      [options]="{prefix: ''+prefix, thousands: ''+miles, decimal: ''+decimal, precision: 0,suffix: ' %', align: aling}" formControlName="porACont">
                    </div>
                  </div>
                </div>
                <div class="w3-half" style="margin-top: 1vh;">
                  <div class="texto">
                    <div class="w3-right zonaTexto2"><span class="w3-right textoInputs"> {{'operative.matriz-eventos.formulario-opcion-nivel-exposicion'|translate}}: </span></div>
                  </div>
                  <div class="w3-rest">
                    <div class="zonaInput">
                      <input type="text" class="contentInput" formControlName="nivelExp">
                    </div>
                  </div>
                </div>

                <mat-action-row style="margin-top: 1vh;">
                  <div class="botonesModales" (click)="prevStep()">
                    <button mat-stroked-button color="success2" style="height: 3vh; width: 100%;">{{'operative.matriz-eventos.botones-form-1' | translate}}</button>
                  </div>
                  <div class="botonesModales" (click)="nextStep()">
                    <button mat-stroked-button color="success" style="height: 3vh; width: 100%;">{{'operative.matriz-eventos.botones-form-2' | translate}}</button>
                  </div>
                </mat-action-row>

              </mat-expansion-panel>
              <!-- Zona 4 -->
              <mat-expansion-panel [expanded]="step === 3" (opened)="setStep(3)">
                <mat-expansion-panel-header style="background-color: rgb(230, 230, 230);">
                  <mat-panel-title>
                    <span class="w3-margin-left-contenido tituloZonasMatDivider"> {{'operative.matriz-eventos.zona-form-4' | translate}} </span>
                  </mat-panel-title>
                </mat-expansion-panel-header>

                <br>
                <div class="w3-row">
                  <div style="margin-top: 1vh;">
                    <div class="texto">
                      <div class="w3-right zonaTexto"><span class="w3-right textoInputs"> {{'operative.matriz-eventos.formulario-opcion-recomendacion-riesgos'|translate}}: </span></div></div>
                    <div class="w3-rest" style="height: 5vh;">
                      <input type="text" class="contentInput" style="width: 88%; height: 75%;" formControlName="recomRies">
                    </div>
                  </div>
                  <div style="margin-top: 1vh;">
                    <div class="texto">
                      <div class="w3-right zonaTexto"><span class="w3-right textoInputs"> {{'operative.matriz-eventos.formulario-opcion-plan-trabajo'|translate}}: </span></div></div>
                    <div class="w3-rest" style="height: 5vh;">
                      <input type="text" class="contentInput" style="width: 88%; height: 75%;" formControlName="plan">
                    </div>
                  </div>
                </div> 
                <div class="w3-row">
                  <div class="w3-half">
                    <div style="margin-top: 1vh;">
                      <div class="texto">
                        <div class="w3-right zonaTexto"><span class="w3-right textoInputs"> {{'operative.matriz-eventos.formulario-opcion-fecha-dead'|translate}}: </span></div></div>
                      <div class="w3-rest">
                        <div class="zonaInput">
                          <input type="date" class="contentDate" onclick="" formControlName="fechaDead">
                        </div>
                      </div>
                    </div>
                    <div style="margin-top: 1vh;">
                      <div class="texto">
                        <div class="w3-right zonaTexto2"><span class="w3-right textoInputs"> {{'operative.matriz-eventos.formulario-opcion-registra'|translate}}: </span></div>
                      </div>
                      <div class="w3-rest">
                        <div class="zonaInput">
                          <input type="text" value="{{dataService.user}}" class="contentInput" formControlName="quienReg">
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="w3-half">
                    <div style="margin-top: 1vh;">
                      <div class="texto">
                        <div class="w3-right zonaTexto"><span class="w3-right textoInputs"> {{'operative.matriz-eventos.formulario-opcion-estatus-plan'|translate}}: </span></div>
                      </div>
                      <div class="w3-rest">
                        <div class="zonaInput">
                          <select class="contentSelect" formControlName="estatusPlan" value="default">
                            <option value="default"> Seleccione: </option>
                            @for (opt of estatus; track $index) {
                              <option value="{{opt.id}}">{{opt.name}}</option>
                            }
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <mat-action-row style="margin-top: 1vh;">
                  <div class="botonesModales" (click)="prevStep()">
                    <button mat-stroked-button color="success2" style="height: 3vh; width: 100%;">{{'operative.matriz-eventos.botones-form-1' | translate}}</button>
                  </div>
                </mat-action-row>

              </mat-expansion-panel>
            </mat-accordion>
            
          </div>
          <div class="w3-right" style="margin-top: 1vh;">
            <div class="zonaBotones">
              <ng-container *appRoles="permisos.VALIDACION">
                @if (edi && itemEdicion.estatusEvent === 1) {
                  <div class="botonesModales" [ngClass]="puedeGuardar()">
                    <button mat-flat-button color="success" style="height: 3vh; width: 100%;" (click)="guardarInfo(3)">Validar</button>
                  </div>
                  <div class="botonesModales" [ngClass]="puedeGuardar()">
                    <button mat-flat-button color="success" style="height: 3vh; width: 100%;" (click)="guardarInfo(4)">Rechazar</button>
                  </div>
                }
              </ng-container>
              <div class="botonesModales" [ngClass]="puedeGuardar()">
                <button mat-flat-button color="success" style="height: 3vh; width: 100%;" (click)="guardarInfo(1)">Guardar</button>
              </div>
              <div class="botonesModales" (click)="cerrar()">
                <button mat-stroked-button color="success2" style="height: 3vh; width: 100%;">Cancelar</button>
              </div>
            </div>
          </div>
        </div>
        <div class="w3-row" style="margin-top: 1%;">
        </div>
      </div>
      <div class="w3-row tableZone" style="height: 1vh;"></div>
    </div>
  </div>
</div>